/**
 * A valid empty A4 page, for a replay whose export carried no source document.
 *
 * The seeding endpoint stores a source document for every transaction — the preview and download
 * routes assume one — but a debug export deliberately omits the PDF, so a replay has nothing to
 * send unless the reporter also attached it.
 *
 * Hand-written rather than built with `pdf-lib`, which the app already depends on, for one reason:
 * `pnpm seed` needs the same stand-in, and the e2e package resolves its own dependencies. Zero
 * imports is what lets both runtimes share this. The xref invariant is pinned by its tests.
 */

/** All ASCII, so string length is byte length — which is what the xref offsets are measured in. */
export function blankPdf(): string {
  const objects = [
    '<</Type/Catalog/Pages 2 0 R>>',
    '<</Type/Pages/Kids[3 0 R]/Count 1>>',
    '<</Type/Page/Parent 2 0 R/MediaBox[0 0 595 842]/Resources<<>>>>',
  ];

  let pdf = '%PDF-1.4\n';
  const offsets = objects.map((body, index) => {
    const offset = pdf.length;
    pdf += `${index + 1} 0 obj\n${body}\nendobj\n`;
    return offset;
  });

  const startxref = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  for (const offset of offsets) pdf += `${String(offset).padStart(10, '0')} 00000 n \n`;
  pdf += `trailer\n<</Size ${objects.length + 1}/Root 1 0 R>>\nstartxref\n${startxref}\n%%EOF\n`;

  return pdf;
}

export const blankPdfBlob = (): Blob => new Blob([blankPdf()], { type: 'application/pdf' });
